import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OurFinancialExpertise from "./sections/OurFinancialExpertise";
import TailoredSolutions from "./sections/TailoredSolutions";
import VisualizingSuccess from "./sections/VisualizingSuccess";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OurFinancialExpertise />
      <TailoredSolutions />
      <VisualizingSuccess />
      <Footer />
    </div>;
}